import React from 'react';
import { Box } from '@mui/material';

const Scroll = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <Box
      sx={{
        marginTop: isMobile ? "2rem" : "10rem",
        marginBottom: isMobile ? "0" : "-10rem",
        backgroundImage: `url(https://www.cloudix.ai/assests/images/cloudix-wallpaper.png)`,
        backgroundSize: 'cover',
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        overflowY: 'scroll',
        transform: isMobile ? "" : "translateY(-10rem)",
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
      }}
    >

      {[...Array(5)].map((_, index) => (
        <img
          key={index}
          src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Scroll Group 7.png`}
          loading="lazy"
          alt="Scroll Image"
          width={isMobile ? "100%" : "40%"}
          height={isMobile ? "auto" : "auto"}
          style={{ marginBottom: isMobile ? '20px' : '40px' }}
        />
      ))}
    </Box>
  );
};

export default Scroll;
